<template>
    <div class="modal-content">
        <!-- 第一行：视频播放和证据列表 -->
        <div class="modal-row">
            <!-- 左侧：视频播放和问题描述 -->
            <div class="modal-left ">
                <div class="video-section modal-card">
                    <h4 class="section-title video-title">视频播放</h4>


                    <div id="J_prismPlayer2"></div>

                </div>
                <div class="problem-description modal-card">
                    <h4 class="section-title problem-title">存在问题描述</h4>
                    <p>{{ combinedReasons }}</p>
                </div>
            </div>

            <!-- 右侧：证据列表表格 -->
            <div class="modal-right modal-card">
                <div class="evidence-section">
                    <h4 class="section-title evidence-title">证据列表</h4>
                    <div class="evidence-table-container">
                        <el-table :data="data.evidences" style="width: 100%; height: 100%" :border="false" height="100%"
                            :header-cell-style="{ background: 'rgba(5, 133, 247, 0.2)', color: '#9ED1FF', fontWeight: '500' }"
                            class="custom-scrollbar-table" ref="evidenceTable">
                            <el-table-column prop="startTime" label="开始时间" width="120"></el-table-column>
                            <el-table-column prop="endTime" label="结束时间" width="120"></el-table-column>
                            <el-table-column prop="text" label="对话文本"></el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>

        <!-- 第二行：折线图 -->
        <div class="modal-row chart-row modal-card">
            <div class="chart-section">
                <h4 class="section-title chart-title">{{data.indicatorName}}</h4>
                <EvidenceChart :gain="data.gainList" :loss="data.lossList" width="100%" height="200px">
                </EvidenceChart>
            </div>
        </div>
    </div>
</template>

<script>

import { getStstoken } from '@/request/api/user.js'
import EvidenceChart from './EvidenceChart.vue';
export default {
    name: 'DetailModal',
    components: {
        EvidenceChart
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => ({
                title: '详细信息',
                videoId: '',
                indicatorName:'',
                evidences: [],
                lossList: [],
                gainList: [],
            })
        }
    },
    data() {
        return {
            chartInstance: null
        }
    },

    mounted() {

        this.startVideo(this.$props.data.videoId)
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.customizeTableScrollbars();
                });
            } else {
                this.disposeChart();
            }
        }
    },
    computed: {
        combinedReasons() {
            // 拼接evidences数组中所有reason字段的值，如果不存在则使用默认描述
            if (!this.data.evidences || !Array.isArray(this.data.evidences)) {
                return this.data.problemDescription || '暂无问题描述信息';
            }

            const reasons = this.data.evidences
                .filter(item => item.reason && typeof item.reason === 'string')
                .map(item => item.reason);

            return reasons.length > 0 ? reasons.join(' ') : this.data.problemDescription || '暂无问题描述信息';
        },



    },

    methods: {
        close() {
            this.$emit('update:visible', false);
            this.$emit('close');
        },
        handleOverlayClick() {
            this.close();
        },
        disposeChart() {
            if (this.chartInstance) {
                this.chartInstance.dispose();
                this.chartInstance = null;
            }
            window.removeEventListener('resize', this.handleChartResize);
        },
        customizeTableScrollbars() {
            // 等待DOM更新
            this.$nextTick(() => {
                const tableWrapper = this.$el.querySelector('.evidence-table-container .el-table__body-wrapper');
                if (tableWrapper) {
                    // 创建样式标签
                    const styleId = 'custom-table-scrollbar';
                    if (!document.getElementById(styleId)) {
                        const style = document.createElement('style');
                        style.id = styleId;
                        style.textContent = `
                            /* 强制覆盖所有el-table滚动条样式 - 只显示Y轴滚动条 */
                            .evidence-table-container .el-table__body-wrapper {
                                overflow-y: auto !important;
                                overflow-x: hidden !important;
                                scrollbar-width: thin !important;
                                scrollbar-color: rgba(5, 133, 247, 0.8) rgba(0, 28, 53, 0.1) !important;
                            }
                            
                            .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar {
                                width: 2px !important;
                                height: 0 !important; /* 隐藏X轴滚动条 */
                                background: transparent !important;
                            }
                            
                            .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar:horizontal {
                                display: none !important; /* 完全隐藏水平滚动条 */
                            }
                            
                            .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar-track {
                                background: rgba(0, 28, 53, 0.1) !important;
                                border-radius: 1px !important;
                                border: none !important;
                            }
                            
                            .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar-thumb {
                                background: rgba(5, 133, 247, 0.8) !important;
                                border-radius: 1px !important;
                                border: none !important;
                                min-height: 20px !important;
                            }
                            
                            .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
                                background: rgba(5, 133, 247, 1) !important;
                            }
                            
                            .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar-corner {
                                background: transparent !important;
                            }
                            
                            .evidence-table-container .el-table__body-wrapper::-webkit-scrollbar-button {
                                display: none !important;
                            }
                        `;
                        document.head.appendChild(style);
                    }

                    // 强制重绘滚动条
                    tableWrapper.style.overflowY = 'auto';
                    tableWrapper.style.overflowX = 'hidden';
                    tableWrapper.style.scrollbarWidth = 'thin';
                    tableWrapper.style.scrollbarColor = 'rgba(5, 133, 247, 0.8) rgba(0, 28, 53, 0.1)';

                    // 重新触发滚动条渲染
                    const scrollTop = tableWrapper.scrollTop;
                    tableWrapper.scrollTop = scrollTop + 1;
                    tableWrapper.scrollTop = scrollTop;

                    // 强制添加类名
                    tableWrapper.classList.add('custom-scrollbar');
                }
            });
        },
        startVideo(url) {
            let self = this
            getStstoken().then(res => {
                var info = res.data.credentials
                var accessKeyId = info.accessKeyId
                var accessKeySecret = info.accessKeySecret
                var securityToken = info.securityToken
                self.aliplayer = self.getStartVideo(url, accessKeyId, securityToken, accessKeySecret)
            })

        },
        getStartVideo(videoId, accessKeyId, securityToken, accessKeySecret) {
            return new window.Aliplayer({
                id: 'J_prismPlayer2',
                width: '100%',
                height: '200px',
                vid: videoId, // 必选参数。音视频ID可以在音视频上传完成后通过控制台（路径：媒资库 > 音/视频。）或服务端接口（SearchMedia ）获取。示例：1e067a2831b641db90d570b6480f****。
                accessKeyId: accessKeyId, // 必选参数。STS临时AK对的访问密钥ID，生成STS安全令牌时返回。
                securityToken: securityToken, // 必选参数。STS安全令牌，需要调用STS服务的AssumeRole接口生成。
                accessKeySecret: accessKeySecret, // 必选参数。STS临时AK对的访问密钥，生成STS安全令牌时返回。
                region: 'cn-beijing', // 必选参数。媒体资源所在的地域标识。如cn-shanghai、eu-central-1, ap-southeast-1等。
                autoplay: false,
                // authTimeout: 7200, // 播放地址的有效时长，单位：秒。该时长会覆盖在视频点播控制台设置的URL鉴权的有效时长。如果不传，则取默认值7200。如需设置此参数，请确保该时间大于视频的实际时长，防止播放地址在播放完成前过期。
            }, function (player) {
                console.log('The player is created.')
            });

        },
        getCurrentTime() {
            return this.aliplayer.getCurrentTime()
        }
    },
    beforeDestroy() {
        this.disposeChart();
    }
}
</script>

<style scoped lang="less">
.modal-content {
    width: 100%;
    height: 802px;
    // padding: 20px;
    overflow: hidden;
}

.modal-card {
    background: rgba(0, 74, 140, 0.3);
}

.modal-row {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
}

.modal-row:first-child {
    height: 582px;
}

.chart-row {
    width: 100%;
    height: 210px;
    background: rgba(0, 74, 140, 0.3);
    padding: 15px;
    box-sizing: border-box;
}

.chart-section {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.chart-content {
    flex: 1;
    width: 100%;
}

.modal-left {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.modal-right {
    flex: 2;
    min-width: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.video-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
}

.modal-video {
    width: 100%;
    height: 200px;
    background: #000;
    border-radius: 4px;
    border: 1px solid rgba(5, 133, 247, 0.3);
}

/* 统一的标题样式 */
.section-title {
    position: relative;
    padding-left: 20px;
    margin: 0 0 15px 0;
    color: #9ED1FF;
    font-size: 16px;
    font-weight: 500;
}

.section-title::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    background: url(../../../assets/image/modal-indicator.png) no-repeat center center;
    background-size: contain;
}

.problem-description {
    background: rgba(0, 28, 53, 0.5);
    padding: 15px;
    border-radius: 4px;
    border: 1px solid rgba(5, 133, 247, 0.2);
    flex: 1;
    overflow-y: auto;
    margin-top: 20px;
}

.problem-description .problem-title {
    margin-bottom: 10px;
}

.problem-description p {
    color: #FFFFFF;
    margin: 0;
    line-height: 1.5;
    font-size: 16px;
    line-height: 30px;
}

.evidence-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
    min-height: 0;
}

.evidence-section .evidence-title {
    margin-bottom: 15px;
}

.evidence-table-container {
    flex: 1;
    overflow: hidden;
    border: 1px solid rgba(5, 133, 247, 0.3);
    border-radius: 4px;
    background: rgba(0, 28, 53, 0.3);
    min-height: 0;
    /* 强制自定义滚动条 - 只显示Y轴滚动条 */
    --scrollbar-width: 2px;
    --scrollbar-height: 0;
    /* 隐藏X轴滚动条 */
    --scrollbar-track-bg: rgba(0, 28, 53, 0.1);
    --scrollbar-thumb-bg: rgba(5, 133, 247, 0.8);
    --scrollbar-thumb-hover-bg: rgba(5, 133, 247, 1);
}

/* 自定义弹窗滚动条 */
.modal-body::-webkit-scrollbar {
    width: 6px;
}

.modal-body::-webkit-scrollbar-track {
    background: rgba(0, 28, 53, 0.1);
    border-radius: 3px;
}

.modal-body::-webkit-scrollbar-thumb {
    background: rgba(5, 133, 247, 0.5);
    border-radius: 3px;
}

.modal-body::-webkit-scrollbar-thumb:hover {
    background: rgba(5, 133, 247, 0.8);
}

/* el-table滚动条强制自定义样式 */
.evidence-table-container *::-webkit-scrollbar {
    width: 2px !important;
    height: 2px !important;
}

.evidence-table-container *::-webkit-scrollbar-track {
    background: rgba(0, 28, 53, 0.1) !important;
    border-radius: 1px !important;
}

.evidence-table-container *::-webkit-scrollbar-thumb {
    background: rgba(5, 133, 247, 0.8) !important;
    border-radius: 1px !important;
    border: none !important;
}

.evidence-table-container *::-webkit-scrollbar-thumb:hover {
    background: rgba(5, 133, 247, 1) !important;
}

/* 强制隐藏系统默认滚动条 */
.evidence-table-container .el-table__body-wrapper,
.evidence-table-container .el-table__fixed-body-wrapper,
.evidence-table-container .el-table__fixed-right-body-wrapper {
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
}

.evidence-table-container .el-table__body-wrapper::-webkit-scrollbar,
.evidence-table-container .el-table__fixed-body-wrapper::-webkit-scrollbar,
.evidence-table-container .el-table__fixed-right-body-wrapper::-webkit-scrollbar {
    width: 2px !important;
    height: 2px !important;
}

/* 深度作用域选择器确保样式生效 */
.evidence-table-container /deep/ .el-table__body-wrapper::-webkit-scrollbar,
.evidence-table-container /deep/ .el-table__fixed-body-wrapper::-webkit-scrollbar,
.evidence-table-container /deep/ .el-table__fixed-right-body-wrapper::-webkit-scrollbar {
    width: 2px !important;
    height: 2px !important;
}

.evidence-table-container /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb,
.evidence-table-container /deep/ .el-table__fixed-body-wrapper::-webkit-scrollbar-thumb,
.evidence-table-container /deep/ .el-table__fixed-right-body-wrapper::-webkit-scrollbar-thumb {
    background: rgba(5, 133, 247, 0.8) !important;
    border-radius: 1px !important;
}

/* Vue3的:deep()选择器 */
.evidence-table-container :deep(.el-table__body-wrapper::-webkit-scrollbar) {
    width: 2px !important;
    height: 2px !important;
}

.evidence-table-container :deep(.el-table__body-wrapper::-webkit-scrollbar-thumb) {
    background: rgba(5, 133, 247, 0.8) !important;
    border-radius: 1px !important;
}
</style>